// Dependencies

// Styles
require("./fiche-onglet-1-1.scss");

require('waypoints/lib/jquery.waypoints.min.js');

// JavaScript
require.ensure(['jquery'], function () {
    require('waypoints/lib/jquery.waypoints.min.js');
    var $ = require('jquery');

    if (window.matchMedia("(min-width: 992px)").matches) {
        stickSubMenu(80);
    } else {
        stickSubMenu(60);
    }

    function stickSubMenu(principalNavHeight) {
        $('.js-fiche-onglet').each(function () {
            var onglets = $(this);

            if (onglets.length > 0) {
                onglets.waypoint(function (direction) {
                    onglets.find('.fiche-onglet-1-1__list-tabs').toggleClass('fiche-onglet-1-1__list-tabs--fixed')
                }, {
                    offset: principalNavHeight
                })
            }
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/fiche-onglet-1/view-1/index.js
// module id = 193
// module chunks = 0